// extracted by mini-css-extract-plugin
export default {"profile-menu-selector":"ProfileMenu_profile-menu-selector__EIXZQ"};